import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type CommentsSliceState = {
  scrollTopPx: number
  stepId?: string
  intentId?: string
}

export const initialState: CommentsSliceState = {
  scrollTopPx: 0,
  stepId: undefined,
  intentId: undefined
}

export const slice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    setScrollTopPx: (state, action: PayloadAction<number>) => {
      state.scrollTopPx = action.payload
    },
    setStepId: (state, action: PayloadAction<string | undefined>) => {
      state.stepId = action.payload
    },
    setIntentId: (state, action: PayloadAction<string | undefined>) => {
      state.intentId = action.payload
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
